import Vue from 'vue';
import MediaPickerModal from './MediaPickerModal.vue';

/**
 * Open the media-library browser as a modal in THIS window and resolve with the
 * picked item (or null if cancelled). Registered on `window.galaxyMediaPicker`.
 *
 * Meant to run in the admin window so the modal sits in front of Galaxy at the
 * real viewport — the canvas editor iframe calls `window.parent.galaxyMediaPicker`
 * so the modal isn't trapped inside the (tall, auto-resized) canvas iframe.
 */
function open(options) {
    options = options || {};

    return new Promise(function (resolve) {
        var htmlPrefix = $('html').data('prefix');
        var base = '/' + (htmlPrefix !== undefined ? htmlPrefix : 'admin/') + 'modules/media-library/';

        var mount = document.createElement('div');
        document.body.appendChild(mount);

        var settled = false;
        var app;

        function finish(result) {
            if (settled) return;
            settled = true;
            resolve(result || null);
            // Vue 2 $mount(el) REPLACES `mount` with the component root, so we must
            // remove app.$el (removing `mount` is a no-op — it's already detached).
            var el = app ? app.$el : null;
            if (app) { try { app.$destroy(); } catch (e) {} }
            if (el && el.parentNode) { el.parentNode.removeChild(el); }
            if (mount.parentNode) { mount.parentNode.removeChild(mount); }
        }

        app = new Vue({
            render: function (h) {
                return h(MediaPickerModal, {
                    props: {
                        itemsUrl: base + 'items',
                        statsUrl: base + 'stats',
                        uploadUrl: base + 'upload',
                        deleteUrl: base + 'delete',
                        detailUrl: base + 'item',
                        initialType: options.type || '',
                    },
                    on: {
                        select: function (item) { finish(item); },
                        close: function () { finish(null); },
                    },
                });
            },
        });

        app.$mount(mount);
    });
}

window.galaxyMediaPicker = { open: open };
